import { createAPI } from '@common'
export default {
  /* getMamDownload: (config) => createAPI('customEncryptApiName-1/0w20nbn0epxompbe', 'GET', config), */
  getMamDownload: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0nbn0epxompbe', 'post', config), // 音频下载
  getMamAudioDetail: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0bvejp0efubjm', 'GET', config, vconfig), // 音频详情
  getMamVideoDetail: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0efubjm', 'GET', config, vconfig), // 视频详情
  // 删除单个视频文件 (和视频是同一个接口)
  deleteSingleFile: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0wjefp0usbotGjmf0efm', 'post', config),
  postMamAudioDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0bvejp0vqebufefubjm', 'POST', config), // 音频基础信息修改
  // 音视频智能审核
  getAiAsync: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0nbn0joufmmjhfodf0hfuWjefpDfotps', 'POST', config),
  deleteMamAudioDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0bvejp0efmfuf', 'POST', config), // 音频删除
  /* getMamAudioStatusUse: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bvejp0tubuvt0vtf', 'GET', config), // 引用状态检查
  deleteMamAudioDelete: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bvejp0efmfuf', 'DELETE', config), // 音频删除
  // 编目基础信息查询
  getMamAudioExtfields: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bvejp0fyugjfmet', 'GET', config),
  // 编目信息修改
  postMamAudioExtfields: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bvejp0fyugjfmet', 'POST', config),
  getMamAudioMaterielUse: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bvejp0nbufsjfm0vtf', 'GET', config),
  // 开启音频检测
  postMamAiAudioAsyncscan: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bj0bvejp0btzodtdbo', 'post', config),
  // 音视频智能检测接口
  getAiAsync: (config) => createAPI('customEncryptApiName-1/0w20nbn0bj0btzod', 'GET', config),
  // 音视频智能检测接口
  getAudioAiAsync: (config) =>
    createAPI('customEncryptApiName-1/w20nbn0bj0bvejp0btzod', 'GET', config),
  // 各种经检测状态
  getAiStatus: (config) => createAPI('customEncryptApiName-1/0w20nbn0bj0tubuvt', 'GET', config)
 */
}
